// extracted by css-extract-rspack-plugin
export default {"root":"root-PRPdg0","workspaceFilter":"workspaceFilter-qWs247","documentsTable":"documentsTable-u5un54"};